import { styled } from '@mui/material/styles';

// Fills remaining space under document/course chrome. The iframe scrolls inside;
// the parent Document/CourseDocument panel should not scroll for this type.
export const StyledContainer = styled('div')(({ theme }) => ({
  flex: '1 1 auto',
  minHeight: 0,
  width: '100%',
  boxSizing: 'border-box',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  padding: theme.spacing(2),

  [theme.breakpoints.down('md')]: {
    padding: 0,
  },

  pageBreakInside: 'avoid !important',
}));
